import { useScript } from './useScript';

export const useLoadGoogleTagManager = (gtmId) => {
  useScript({
    id: 'gtm-callback',
    position: document.querySelector('head'),
    innerHTML: `
      (function (w, l) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      })(window, 'dataLayer');
    `,
    validateOnlyProduction: true,
  });

  useScript({
    id: 'gtm-initialized',
    position: document.querySelector('head'),
    src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}`,
    async: true,
    validateOnlyProduction: true,
  });
};
